var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"existing-account-footer"},[_c('div',{staticClass:"existing-account-footer-container"},[_vm._v("\n\t\tAlready have an account?\n\t\t"),_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v("\n\t\t\tSign in\n\t\t")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }